import { ClientEntity } from 'src/app/models/clients';
import { humanizeEnum } from "../services/utils/humanize-enum";

export interface IDocument {
    myDocumentId: number;
    documentType: DocumentType;
    documentCategory: DocumentCategory;
    requirementId?: number;
    investorEntityId?: number;
    fileName: string;
    fileType: string;
    uploadDate: string;
    displayDate: string;
    name: string;
    token: string;
}

export enum DocumentCategory {
    PortfolioReports = 0,
    DisclosureDocuments = 1,
    Contracts = 2,
    AmlDocuments = 3,
}

export enum DocumentType {
    TrustDeed = 0,
    ProofOfAddress = 1,
    CopyOfPassport = 2,
    CopyOfDrivingLicense = 3,
    CopyOfBirthCertificate = 4,
    InvestorReport = 5,
    FundDisclosure = 6,
    Prospectus = 7,
    Contract = 8,
    CertIncorporation = 9,
    TaxSummaryReport = 10,
    PieTaxCertificate = 11,
    PeidReport = 12,
    Identity = 13, // An identity document which is set when the member manually verifies and doesn't specify the document type
    ManagementAccountsReport = 14,
    GeneralLedgerReport = 15,
    TermsAndConditions = 16,
    InvestorReportByClassification = 17,
    APSReport = 18,
    TrustAddress = 19,
    SourceOfWealth = 20,
    CompanyExtract = 21,
    KiwiSaverAnnualMemberStatement = 22,
    ProofOfBankAccount = 23,
    DimsReport = 24,
    CustodyReport = 25,
    AMLDocumentUsage = 26,
    InvestorListReport = 27,
    AllHoldingsReport = 28,
    CapitalMovementsReport = 29,
    PortfolioPerformanceReport = 30,
    MemberListReport = 31,
    WholesaleInvestorDeclaration = 32,
    MarginReport = 33
}

export function getDocumentTypeString(documentType: DocumentType){
    switch (documentType) {
        case DocumentType.FundDisclosure:
            return "Product Disclosure Documents";
        case DocumentType.InvestorReportByClassification:
            return "Investor Reports";
        case DocumentType.TaxSummaryReport:
            return "Tax Summary Report";
        case DocumentType.PieTaxCertificate:
            return "PIE Tax Certificates";
        default:
            return humanizeEnum(DocumentType[documentType]);
    }
    
}




export interface IGetDocumentsParams {
    entityIds: ClientEntity[];
    toDate: Date;
}

export interface IDocumentsQueryResult {
    documentsList: any;
    clientEntityIds: ClientEntity[];
}

export interface IDocumentDownloadRequestObject {
    token: string;
    fileType: string;
    fileName: string;
}

export enum FileType {
    XLS = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    PDF = 'application/pdf',
    OCTET_STREAM = 'application/octet-stream'
}
